import _asyncToGenerator from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _classCallCheck from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/build/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { metaSchemas } from "@/lib/constants";
import { channelsSort, genreSort, searchSort, searchTvShowSort, titlesSort } from "@/lib/sorts";
import merge from "deepmerge";
import LogicaAPI from "./logicaapi";

var Meta = /*#__PURE__*/function (_LogicaAPI) {
  _inherits(Meta, _LogicaAPI);

  var _super = _createSuper(Meta);

  function Meta() {
    _classCallCheck(this, Meta);

    return _super.apply(this, arguments);
  }

  _createClass(Meta, [{
    key: "howtoPlay",
    value: function howtoPlay(id) {
      var params = {
        app_id: this.config.appId,
        device_code: this.config.deviceCode,
        with_howto_acquisition: true,
        expand_object_flag: true
      };
      return this.get("/api/v1/metas/".concat(id, "/howto_play"), {
        params: params
      });
    }
  }, {
    key: "children",
    value: function children(_ref) {
      var id = _ref.id,
          offset = _ref.offset,
          limit = _ref.limit,
          _ref$filter = _ref.filter,
          filter = _ref$filter === void 0 ? {} : _ref$filter,
          _ref$sort = _ref.sort,
          sort = _ref$sort === void 0 ? [] : _ref$sort;

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        expand_object_flag: false,
        with_total_count: true,
        condition: merge(_objectSpread({
          meta_schema_id: metaSchemas.episode.id,
          "values.tv_show": id,
          time_range: {
            delivery_end_at: {
              gt: "now"
            }
          }
        }, this.dsearchCommonCondition), filter),
        sort: merge([{
          "values.num": "asc"
        }, {
          delivery_start_at: "asc"
        }, {
          id: "desc"
        }], sort),
        from: offset,
        limit: limit
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "channels",
    value: function channels(_ref2) {
      var offset = _ref2.offset,
          limit = _ref2.limit,
          _ref2$filter = _ref2.filter,
          filter = _ref2$filter === void 0 ? {} : _ref2$filter,
          _ref2$sort = _ref2.sort,
          sort = _ref2$sort === void 0 ? "pr" : _ref2$sort;
      var sortOrder;

      if (sort == "mylist") {
        sortOrder = {
          sort: [{
            entitled_at: "desc"
          }, {
            id: "desc"
          }]
        };
      } else {
        sortOrder = channelsSort.find(function (v) {
          return v.value == sort;
        });
      }

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        expand_object_flag: false,
        with_total_count: true,
        condition: merge(_objectSpread({
          meta_schema_id: metaSchemas.channel.id
        }, this.dsearchCommonCondition), filter),
        sort: sortOrder.sort,
        from: offset,
        limit: limit
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "channelFeatureEpisodes",
    value: function channelFeatureEpisodes(_ref3) {
      var id = _ref3.id,
          offset = _ref3.offset,
          limit = _ref3.limit;

      // vod、live、見逃し全て含める
      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        expand_object_flag: false,
        with_total_count: true,
        condition: _objectSpread({
          meta_schema_id: metaSchemas.episode.id,
          "values.channel": id,
          time_range: {
            delivery_end_at: {
              gt: "now"
            }
          }
        }, this.dsearchCommonCondition),
        sort: [{
          push_rank: "desc"
        }, {
          name: "asc"
        }, {
          id: "desc"
        }],
        from: offset,
        limit: limit
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "channelDetail",
    value: function () {
      var _channelDetail = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var _res$metas;

        var params, res;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  condition: _objectSpread({
                    meta_schema_id: metaSchemas.channel.id,
                    id: id
                  }, this.dsearchCommonCondition)
                });
                _context.next = 3;
                return this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                });

              case 3:
                res = _context.sent;
                return _context.abrupt("return", res === null || res === void 0 ? void 0 : (_res$metas = res.metas) === null || _res$metas === void 0 ? void 0 : _res$metas[0]);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function channelDetail(_x) {
        return _channelDetail.apply(this, arguments);
      }

      return channelDetail;
    }()
  }, {
    key: "searchEpisode",
    value: function () {
      var _searchEpisode = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref4) {
        var keyword, _ref4$filter, filter, _ref4$sort, sort, offset, limit, _ref4$minScore, minScore, sortOrder, params;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                keyword = _ref4.keyword, _ref4$filter = _ref4.filter, filter = _ref4$filter === void 0 ? {} : _ref4$filter, _ref4$sort = _ref4.sort, sort = _ref4$sort === void 0 ? "rel" : _ref4$sort, offset = _ref4.offset, limit = _ref4.limit, _ref4$minScore = _ref4.minScore, minScore = _ref4$minScore === void 0 ? null : _ref4$minScore;
                sortOrder = searchSort.find(function (v) {
                  return v.value == sort;
                });
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  with_total_count: true,
                  keyword: keyword,
                  condition: merge(_objectSpread({
                    meta_schema_id: metaSchemas.episode.id,
                    time_range: {
                      delivery_end_at: {
                        gt: "now"
                      }
                    }
                  }, this.dsearchCommonCondition), filter),
                  sort: sortOrder.sort,
                  from: offset,
                  limit: limit
                });

                if (!!minScore) {
                  params.min_score = minScore;
                }

                _context2.next = 6;
                return this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                });

              case 6:
                return _context2.abrupt("return", _context2.sent);

              case 7:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function searchEpisode(_x2) {
        return _searchEpisode.apply(this, arguments);
      }

      return searchEpisode;
    }()
  }, {
    key: "searchTvShow",
    value: function () {
      var _searchTvShow = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref5) {
        var keyword, _ref5$filter, filter, _ref5$sort, sort, offset, limit, _ref5$minScore, minScore, sortOrder, params;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                keyword = _ref5.keyword, _ref5$filter = _ref5.filter, filter = _ref5$filter === void 0 ? {} : _ref5$filter, _ref5$sort = _ref5.sort, sort = _ref5$sort === void 0 ? "rel" : _ref5$sort, offset = _ref5.offset, limit = _ref5.limit, _ref5$minScore = _ref5.minScore, minScore = _ref5$minScore === void 0 ? null : _ref5$minScore;
                sortOrder = searchTvShowSort.find(function (v) {
                  return v.value == sort;
                });
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  with_total_count: true,
                  keyword: keyword,
                  condition: merge(_objectSpread({
                    meta_schema_id: metaSchemas.tvshow.id
                  }, this.dsearchCommonCondition), filter),
                  sort: sortOrder.sort,
                  from: offset,
                  limit: limit
                });

                if (!!minScore) {
                  params.min_score = minScore;
                }

                _context3.next = 6;
                return this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                });

              case 6:
                return _context3.abrupt("return", _context3.sent);

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function searchTvShow(_x3) {
        return _searchTvShow.apply(this, arguments);
      }

      return searchTvShow;
    }()
  }, {
    key: "channelLiveSchedule",
    value: function channelLiveSchedule(_ref6) {
      var id = _ref6.id,
          day = _ref6.day,
          offset = _ref6.offset,
          limit = _ref6.limit;

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        expand_object_flag: false,
        with_total_count: true,
        condition: _objectSpread({
          meta_schema_id: metaSchemas.episode.id,
          "values.channel": id,
          time_range: {
            delivery_start_at: {
              gte: "".concat(day, " 00:00:00"),
              lte: "".concat(day, " 23:59:59")
            }
          }
        }, this.dsearchCommonCondition),
        sort: [{
          delivery_start_at: "asc"
        }, {
          push_rank: "desc"
        }, {
          id: "desc"
        }],
        from: offset,
        limit: limit
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "channelLinearEpisodes",
    value: function () {
      var _channelLinearEpisodes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(_ref7) {
        var id, offset, limit, _ref7$filter, filter, params;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                id = _ref7.id, offset = _ref7.offset, limit = _ref7.limit, _ref7$filter = _ref7.filter, filter = _ref7$filter === void 0 ? {} : _ref7$filter;
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  expand_object_flag: false,
                  with_total_count: true,
                  condition: merge(_objectSpread({
                    meta_schema_id: metaSchemas.episode.id,
                    "values.channel": id,
                    "values.is_live": true,
                    time_range: {
                      delivery_end_at: {
                        gt: "now"
                      },
                      "values.encode_end_date": {
                        gt: "now"
                      }
                    },
                    not: {
                      "values.source_epg_id": null
                    }
                  }, this.dsearchCommonCondition), filter),
                  sort: [{
                    delivery_start_at: "asc"
                  }, {
                    id: "desc"
                  }],
                  from: offset,
                  limit: limit
                });
                _context4.next = 4;
                return this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                });

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function channelLinearEpisodes(_x4) {
        return _channelLinearEpisodes.apply(this, arguments);
      }

      return channelLinearEpisodes;
    }()
  }, {
    key: "title",
    value: function () {
      var _title = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(id) {
        var _res$metas2;

        var params, res;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  condition: _objectSpread({
                    meta_schema_id: metaSchemas.tvshow.id,
                    id: id
                  }, this.dsearchCommonCondition)
                });
                _context5.next = 3;
                return this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                });

              case 3:
                res = _context5.sent;
                return _context5.abrupt("return", res === null || res === void 0 ? void 0 : (_res$metas2 = res.metas) === null || _res$metas2 === void 0 ? void 0 : _res$metas2[0]);

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function title(_x5) {
        return _title.apply(this, arguments);
      }

      return title;
    }()
  }, {
    key: "titles",
    value: function () {
      var _titles = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(_ref8) {
        var _ref8$filter, filter, _ref8$sort, sort, offset, limit, sortOrder, params;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref8$filter = _ref8.filter, filter = _ref8$filter === void 0 ? {} : _ref8$filter, _ref8$sort = _ref8.sort, sort = _ref8$sort === void 0 ? "pr" : _ref8$sort, offset = _ref8.offset, limit = _ref8.limit;
                sortOrder = titlesSort.find(function (v) {
                  return v.value === sort;
                });
                params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
                  with_total_count: true,
                  condition: merge(_objectSpread({
                    meta_schema_id: metaSchemas.tvshow.id
                  }, this.dsearchCommonCondition), filter),
                  sort: sortOrder.sort,
                  from: offset,
                  limit: limit
                });
                return _context6.abrupt("return", this.get("/api/v1/metas/dsearch", {
                  params: {
                    q: JSON.stringify(params)
                  }
                }));

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function titles(_x6) {
        return _titles.apply(this, arguments);
      }

      return titles;
    }()
  }, {
    key: "entitled",
    value: function entitled(_ref9) {
      var channelId = _ref9.channelId,
          contentType = _ref9.contentType,
          offset = _ref9.offset,
          limit = _ref9.limit;

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: _objectSpread(_objectSpread({
          is_entitled: true,
          time_range: {
            delivery_end_at: {
              gt: "now"
            }
          }
        }, this.dsearchCommonCondition), this.dsearchContentTypeCondition(contentType)),
        from: offset,
        limit: limit,
        sort: [{
          entitled_at: "desc"
        }, {
          "values.num": "asc"
        }, {
          id: "desc"
        }],
        with_total_count: true
      });

      if (channelId) {
        params.condition["values.channel"] = channelId;
      }

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "getEntitledStoreEpisodes",
    value: function getEntitledStoreEpisodes(args) {
      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: _objectSpread({
          meta_schema_id: metaSchemas.episode.id,
          is_entitled: true,
          time_range: {
            delivery_end_at: {
              gt: "now"
            }
          },
          "values.channel": this.config.storeId
        }, this.dsearchCommonCondition),
        from: args.offset,
        limit: args.limit,
        sort: [{
          entitled_at: "desc"
        }, {
          "values.num": "asc"
        }, {
          id: "desc"
        }],
        with_total_count: true
      });

      var res = this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
      return res;
    }
  }, {
    key: "genrePaletteEpisodes",
    value: function genrePaletteEpisodes(_ref10) {
      var channel = _ref10.channel,
          genre = _ref10.genre,
          offset = _ref10.offset,
          limit = _ref10.limit,
          sortOrder = _ref10.sortOrder,
          type = _ref10.type;
      var sort = genreSort.find(function (v) {
        return v.value == sortOrder;
      });

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: _objectSpread({
          meta_schema_id: metaSchemas.episode.id
        }, this.dsearchCommonCondition),
        from: offset,
        limit: limit,
        sort: sort.sort,
        with_total_count: true
      });

      if (channel) {
        params.condition["values.channel"] = channel;
      }

      if (genre && genre.length > 0 && type === "id") {
        params.condition["values.genres"] = genre;
      } else if (genre && genre.length > 0 && type === "not-id") {
        params.condition["not"] = {
          "values.genres": genre
        };
      }

      var res = this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
      return res;
    }
  }, {
    key: "searchFromId",
    value: function searchFromId(ids, limit) {
      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: _objectSpread({
          id: ids
        }, this.dsearchCommonCondition),
        limit: limit
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "searchFromRightId",
    value: function searchFromRightId(rightId) {
      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: {
          meta_schema_id: metaSchemas.episode.id,
          nested: {
            path: "right_metas",
            condition: {
              "right_metas.right_id": rightId
            }
          }
        },
        limit: 1
      });

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }, {
    key: "rankingSearch",
    value: function rankingSearch(channel, target, range, limit) {
      var order = function () {
        if (range === "1week") {
          return "weekly_ranking";
        } else if (range === "1month") {
          return "monthly_ranking";
        } else if (range === "1day") {
          return "daily_ranking";
        }
      }();

      var params = _objectSpread(_objectSpread({}, this.dsearchCommonParams), {}, {
        condition: _objectSpread({
          meta_schema_id: metaSchemas.episode.id
        }, this.dsearchCommonCondition),
        sort: [_defineProperty({}, target, order)],
        limit: limit
      });

      if (channel) {
        params.condition["values.channel"] = channel;
      }

      return this.get("/api/v1/metas/dsearch", {
        params: {
          q: JSON.stringify(params)
        }
      });
    }
  }]);

  return Meta;
}(LogicaAPI);

export default Meta;